export const mapContainer = height => ({
  height: height,
  width: '100%',
  borderRadius: '0.5rem',
  overflow: 'hidden'
});
